export default function ChatgptResume() {
  return <h2>Chatgpt Resume</h2>;
}
